
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 9.33"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 1.33a.55.55 0 00-.16-.37l-.8-.8a.5.5 0 00-.74 0L8 6.46 1.7.16A.55.55 0 001.33 0a.52.52 0 00-.37.16l-.8.8a.55.55 0 00-.16.37.55.55 0 00.16.37l7.47 7.47a.5.5 0 00.74 0l7.47-7.47a.55.55 0 00.16-.37z"}})])
          )
        }
      }
    